export const purchaseActivitySearchByFields = [
    {
        name: 'amount',
        placeholder: 'Search by amount',
        type: 'number',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
    {
        name: 'purchaseId',
        placeholder: 'Search by Purchase',
        type: 'text',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
    {
        name: 'referenceId',
        placeholder: 'Search by Reference',
        type: 'text',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
    {
        name: 'description',
        placeholder: 'Search by description',
        type: 'text',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
    {
        name: 'venue',
        placeholder: 'Search by Venue',
        type: 'text',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
];

export const purchaseActivityDateFields = [
    {
        name: 'startDate',
        label: 'Start Date',
        placeholder: 'Start Date',
        format: 'YYYY-MM-DD',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
    {
        name: 'endDate',
        label: 'End Date',
        placeholder: 'End Date',
        format: 'YYYY-MM-DD',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
    {
        name: 'expiresAt',
        label: 'Expires At',
        placeholder: 'Expires At',
        format: 'YYYY-MM-DD',
        gridSize: { xs: 12, md: 6, lg: 3 },
    },
];
